import { patchRequest, postRequest, getRequest } from 'apis/ApiInstence';
import { put } from 'redux-saga/effects';
import { successCategory, failedCategory } from 'slice/categorySlice';


export function* updateCategoryAPI({ payload }) {
  try {
    let header = {
      headers: { "Content-Type": "multipart/form-data" }
    }
    yield patchRequest(`category/${payload.id}`, payload.data, header);
    const response = yield getRequest('category');
    if (response?.status == 200) {
      yield put(successCategory(response?.data));
    } else {
      yield put(failedCategory(response));
    }
  } catch (error) {
    console.log(error)
  }
}

export function* addCategoryFun({ payload }) {
  try {
    const response = yield postRequest(`category`, payload);
    if (response?.status == 200) {
      yield put(successCategory(response?.data));
    } else {
      yield put(failedCategory(response));
    }
  } catch (error) {
    console.log(error)
    toast('response.message')
  }
}

export function* searchCategoryByName({ payload }) {
  try {
    const response = yield getRequest(`category/search?category=${payload}`);
    if (response?.status == 200) {
      yield put(successCategory(response?.data));
    } else {
      yield put(failedCategory(response));
    }
  } catch (error) {
    console.log(error)
    toast('response.message')
  }
}


export function* getCategoryFun() {
  try {
    const response = yield getRequest('category');
    if (response?.status == 200) {
      yield put(successCategory(response?.data));
    } else {
      yield put(failedCategory(response));
    }
  } catch (error) {
    console.log(error)
    toast('response.message')
  }
}